import { CountryCodes } from '../../emun/CountryCodes'
import { CountryNames } from '../../emun/CountryNames'

export const RUSSIA = 'Russia'
export const KAZAKHSTAN = 'Kazakhstan'
export const LITHUANIA = 'Lithuania'
export const LATVIA = 'Latvia'
export const ESTONIA = 'Estonia'
export const MOLDOVA = 'Moldova'
export const ARMENIA = 'Armenia'
export const BELARUS = 'Belarus'
export const TAJIKISTAN = 'Tajikistan'
export const TURKMENISTAN = 'Turkmenistan'
export const AZERBAIJAN = 'Azerbaijan'
export const GEORGIA = 'Georgia'
export const KYRGYZSTAN = 'Kyrgyzstan'
export const UZBEKISTAN = 'Uzbekistan'
export const TEST = 'Test'

export interface ICountry {
  countryCode: CountryCodes
  name: keyof typeof CountryCodes
  nameRu: CountryNames
}

export const COUNTRIES_INFO: ICountry[] = [
  {
    countryCode: CountryCodes[RUSSIA],
    name: RUSSIA,
    nameRu: CountryNames[RUSSIA],
  },
  {
    countryCode: CountryCodes[KAZAKHSTAN],
    name: KAZAKHSTAN,
    nameRu: CountryNames[KAZAKHSTAN],
  },
  {
    countryCode: CountryCodes[UZBEKISTAN],
    name: UZBEKISTAN,
    nameRu: CountryNames[UZBEKISTAN],
  },
]
